<!-- @format -->
<!--
  by：llxu7
  name：**
  notes：备注……
-->
<template>
  <div>
    <div class="fixedlefttwo" id="fixedlefttwo">
      <div class="fixeddivtwo">
        <div>
          <a @click="goHref('open')" target="_blank">
            <img
              class="fixedlefttwo_img"
              src="@/assets/img/piaofu-web.png"
            />
          </a>
          <a @click="goHref('close')" class="close">
            <img
              class="fixedleft_close"
              src="@/assets/img/close.png"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from 'lodash';
let DEBOUNCED;
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    goHref(item) {
      if (item == 'open') {
        window.open(
          'https://www.ahedu.cn/EduResource/index.php?app=resource&mod=Homepage&act=viewDetail&level3=57&newsid=3565',
          '_blank'
        );
      } else {
        document.getElementById('fixedlefttwo').style.display = 'none';
      }
    },
    handleResize() {
      //飘窗高度
      // let bh = document.body.clientHeight;
      // let fh = document.getElementById('fixedleft').clientHeight;
      // let fht = document.getElementById('fixedlefttwo').clientHeight;
      // document.getElementById('fixedlefttwo').style.top = bh - fht + 'px';
      // document.getElementById('fixedleft').style.top =
      //   bh - fht - fh - 10 + 'px';
    }
  },
  mounted() {
    window.scaleResize = this.handleResize;
    DEBOUNCED = debounce(this.handleResize, 300);
    window.addEventListener('resize', DEBOUNCED);
    this.$nextTick(() => {
      this.handleResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', DEBOUNCED);
  }
};
</script>

<style scoped lang="less">
.fixedlefttwo {
  position: fixed;
  z-index: 9999;
  // top: calc(50% - -71px);
  top: calc(50% - 20px);
  left: calc(50% - 820px);
  border-radius: 4px;
  overflow: hidden;
  .fixeddivtwo {
    position: relative;
    cursor: pointer;
  }
  .fixedlefttwo_img {
    width: 180px;
    height: 224px;
  }
  .a {
    display: inline-block;
  }
  .fixedleft_close {
    position: absolute;
    z-index: 999;
    width: 20px;
    height: 20px;
    right: 0;
    top: 0;
  }
}
@media screen and (max-width: 1550px) {
  .fixedlefttwo {
    left:calc(50% - 630px);
  }
}
</style>
